export const PROVIDER_DISPLAY_NAME = {
  koalafi: "Koalafi",
  snap: "Snap Finance",
  katapult2: "Katapult",
  katapult: "Katapult",
  uown: "Uown",
  ownlease: "Own Lease",
  aff: "American First Finance",
  paytomorrow: "PayTomorrow",
  kafene: "Kafene",
  progressive: "Progressive",
  kornerstone: "Kornerstone",
  flexshopper: "Flexshopper",
  acima: "Acima",
  creditkey: "Credit Key",
  genesis: "Genesis",
  okinus: "Okinus",
  zip: "Zip",
  bread: "Bread",
};
